'use client';

import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Text from '@/components/ui/Text';

interface IntroStepProps {
	content: string;
	showContinue?: boolean;
	onContinue?: () => void;
}

export default function IntroStep({ content, showContinue = true, onContinue }: IntroStepProps) {
	return (
		<motion.div
			initial={{ opacity: 0, y: 10 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.3 }}
			className="max-w-2xl mx-auto px-4 py-8 md:py-12"
		>
			<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-10 space-y-6">
				<Text content={content} className="max-w-none text-gray-dark" />

				{showContinue && onContinue && (
					<div className="pt-4 border-t border-gray-200 flex justify-end">
						<Button
							type="button"
							onClick={onContinue}
							className="bg-orange hover:bg-orange-hover text-white font-bold px-8 w-full md:w-auto"
						>
							Ga verder naar het formulier <ArrowRight className="ml-2 size-4" />
						</Button>
					</div>
				)}
			</div>
		</motion.div>
	);
}
